<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
        <button
          type="button"
          class="btn btn-primary pull-left"
          @click="onShowModal()"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-plus"></i>
          </span>
          {{ $t("apartment.addCustomerIntoApartment") }}
        </button>
      </div>
    </div>
    <!--  -->
    <div
      class="modal fade add-customer-into-apartment-menu"
      id="modal-add-customer-into-apartment-menu"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("feedback.updateProcessor") }}
            </h4>
          </div> -->
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 add-customer-in-apartment-menu">
                <h4
                  @click="onSelectMenu(1)"
                  class="add-customer-in-apartment-item"
                >
                  {{ $t("apartment.handOverApartment") }}
                </h4>
                <h4
                  @click="onSelectMenu(2)"
                  class="add-customer-in-apartment-item"
                >
                  {{ $t("apartment.addMemberIntoApartment") }}
                </h4>
                <h4
                  @click="onSelectMenu(3)"
                  class="add-customer-in-apartment-item"
                >
                  {{ $t("apartment.rentApartment") }}
                </h4>
                <h4
                  @click="onSelectMenu(4)"
                  class="add-customer-in-apartment-item"
                >
                  {{ $t("apartment.memberRentApartment") }}
                </h4>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
    <div
      class="modal fade"
      id="modal-add-customer-in-apartment"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="onCloseModalAddCustomer()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(modalAddCustomerData.title) }}
              {{ apartmentSelectData.code }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label for="">{{ $t("apartment.customerName") }}: </label>
                <span>{{ customerData && customerData.fullname }}</span>
              </div>
              <div class="col-md-12">
                <label for="dob">{{ $t("customer.dob") }}: </label>
                <span>{{ customerData && customerData.dob }}</span>
              </div>
              <div class="col-md-12">
                <label for="dob">{{ $t("customer.email") }}: </label>
                <span>{{ customerData && customerData.email }}</span>
              </div>
              <div class="col-md-12">
                <label for="dob">{{ $t("customer.phone") }}: </label>
                <span>{{ customerData && customerData.phone }}</span>
                <hr style="margin: 7.5px 0" />
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">{{ $t("apartment.name") }}</label>
                      <v-select
                        class="clear"
                        :options="apartmentList"
                        :reduce="data => data.value"
                        :getOptionLabel="option => $t(option.text)"
                        :placeholder="$t('feedback.apartmentCode')"
                        v-model="addCustomerData.apartmentId"
                        @option:selected="onChangeApartment"
                      >
                        <template v-slot:option="option">
                          {{ option.text }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div
                    v-if="
                      menuSelect === addMemberIntoApartmentEnum ||
                        menuSelect === memberRentApartmentEnum
                    "
                    class="col-md-6"
                  >
                    <div class="form-group">
                      <label for="">{{
                        $t("apartment.relationshipWithOwner")
                      }}</label>
                      <input type="text" class="form-control" v-model="addCustomerData.relationship_note"/>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  apartmentOwnerData.id &&
                    addCustomerData.apartmentId &&
                    (menuSelect === addMemberIntoApartmentEnum ||
                      menuSelect === memberRentApartmentEnum)
                "
              >
                <div class="col-md-12">
                  <label for=""
                    >{{
                      $t(
                        menuSelect === addMemberIntoApartmentEnum
                          ? "customer.headOfAHousehold"
                          : "apartment.apartmentTenant"
                      )
                    }}:
                  </label>
                  <span>{{
                    apartmentOwnerData && apartmentOwnerData.fullName
                  }}</span>
                </div>
                <div class="col-md-12">
                  <label for="dob">{{ $t("customer.dob") }}: </label>
                  <span>{{
                    apartmentOwnerData && apartmentOwnerData.dob
                  }}</span>
                </div>
                <div class="col-md-12">
                  <label for="dob">{{ $t("customer.email") }}: </label>
                  <span>{{
                    apartmentOwnerData && apartmentOwnerData.email
                  }}</span>
                </div>
                <div class="col-md-12">
                  <label for="dob">{{ $t("customer.phone") }}: </label>
                  <span>{{
                    apartmentOwnerData && apartmentOwnerData.phone
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseModalAddCustomer()"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onSaveAddCustomerToApartment()"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Enum from "../../../enum/enum";
export default {
  components: {
    "lte-core-alert": LTECoreAlert
  },
  props: {
    customerId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    customerData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: () => ({
    isLoading: false,
    modalAddCustomerData: {
      title: ""
    },
    menuSelect: null,
    handOverApartmentEnum: 1,
    addMemberIntoApartmentEnum: 2,
    rentApartmentEnum: 3,
    memberRentApartmentEnum: 4,
    //
    apartmentList: [],
    apartmentSelectData: {
      code: null
    },
    addCustomerData: {
      apartmentId: null,
      relationship: null,
      relationship_note: null,
      resident_status: 1,
      is_approved: Enum.ApartmentResidentApprovalEnum.APPROVED
    },
    apartmentOwnerData: {
      id: null,
      fullName: null,
      dob: null,
      email: null,
      phone: null
    }
  }),
  watch: {
    GET_APARTMENT_LIST_NO_PAGE_DATA: function() {
      this.apartmentList = [];
      let data = this.GET_APARTMENT_LIST_NO_PAGE_DATA;
      data.forEach(apartment => {
        let item = {
          value: apartment.id,
          text: apartment.apartment_code
        };
        this.apartmentList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_APARTMENT_LIST_NO_PAGE_DATA"
    ])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    onCloseModal: function() {
      $("#modal-add-customer-into-apartment-menu").modal("hide");
    },
    onShowModal: function() {
      $("#modal-add-customer-into-apartment-menu").modal("show");
    },
    onSelectMenu: function(value) {
      this.menuSelect = value;
      // set data null
      this.addCustomerData.apartmentId = null;
      this.apartmentSelectData.code = null;
      this.getApartmentList();
      switch (value) {
        case 1:
          this.modalAddCustomerData.title = "apartment.handOverApartment";
          break;
        case 2:
          this.modalAddCustomerData.title = "apartment.addMemberIntoApartment";
          break;
        case 3:
          this.modalAddCustomerData.title = "apartment.rentApartment";
          break;
        case 4:
          this.modalAddCustomerData.title = "apartment.memberRentApartment";
          break;
        default:
          break;
      }
      this.onShowModalAddCustomer();
    },
    //
    onShowModalAddCustomer: function() {
      $("#modal-add-customer-in-apartment").modal("show");
    },
    onCloseModalAddCustomer: function() {
      $("#modal-add-customer-in-apartment").modal("hide");
    },
    getUserInApartment: function(apartmentId) {
      let filter = {
        params: {
          apartmentId: apartmentId
        }
      };
      if (this.menuSelect === this.addMemberIntoApartmentEnum) {
        filter.params["isOwner"] = true;
      }
      if (this.menuSelect === this.memberRentApartmentEnum) {
        filter.params["isTenant"] = true;
      }
      this.GET_USER_IN_APARTMENT_LIST(filter).then(
        function(res) {
          this.customerList = [];
          let data = res;
          if (data.length === 1) {
            this.apartmentOwnerData.id = data[0].id;
            this.apartmentOwnerData.fullName =
              data[0].last_name + " " + data[0].first_name;
            this.apartmentOwnerData.email = data[0].email;
            this.apartmentOwnerData.phone = data[0].profile.phone;
            this.apartmentOwnerData.dob = utils.formatSqlDate(data.profile.dob, null, "DD-MM-YYYY");
          } else {
            this.apartmentOwnerData.id = null;
            this.apartmentOwnerData.fullName = null;
            this.apartmentOwnerData.email = null;
            this.apartmentOwnerData.phone = null;
            this.apartmentOwnerData.dob = null;
          }
          data.forEach(value => {
            let item = {
              value: value.id,
              full_name: value.last_name + " " + value.first_name,
              email: value.email
            };
            this.customerList.push(item);
          });
        }.bind(this)
      );
    },
    getApartmentList: function() {
      let apartmentFilter = {
        params: {
          asset: "asset"
        }
      };
      if (this.menuSelect === this.handOverApartmentEnum) {
        apartmentFilter.params["apartmentNotHandOver"] = true;
      }
      if (this.menuSelect === this.addMemberIntoApartmentEnum) {
        apartmentFilter.params["apartmentHandedOver"] = true;
      }
      if (this.menuSelect === this.rentApartmentEnum) {
        // apartmentFilter.params['']
      }
      if (this.menuSelect === this.memberRentApartmentEnum) {
        apartmentFilter.params["rentedApartment"] = true;
      }
      this.GET_APARTMENT_LIST(apartmentFilter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onChangeApartment: function(data) {
      this.apartmentSelectData.code = data.text;
      this.getUserInApartment(data.value);
    },
    validateDate: function() {
      let validateResult = "OK";
      if (utils.isEmptyString(this.addCustomerData.apartmentId)) {
        validateResult = "feedback.apartmentCode";
      }
      if (this.menuSelect === this.addMemberIntoApartmentEnum && utils.isEmptyString(this.apartmentOwnerData.id)) {
        validateResult = "";
      }
      if (this.menuSelect === this.memberRentApartmentEnum && utils.isEmptyString(this.apartmentOwnerData.id)) {
        validateResult = "";
      }
      return validateResult;
    },
    onSaveAddCustomerToApartment: function() {
      let result = this.validateDate();
      if (result === "OK") {
        let data = {
          isMainContact: false,
          isOwner: false,
          isTenant: false,
          resident_movein: null,
          resident_moveout: null,
          start_efigure: null,
          start_wfigure: null,
          resident_status: this.addCustomerData.resident_status,
          relationship: null,
          relationship_note: this.addCustomerData.relationship_note,
          apartment: parseInt(this.addCustomerData.apartmentId),
          resident: this.customerId,
          relationship_to: this.apartmentOwnerData.id,
          is_approved: this.addCustomerData.is_approved
        };
        if (this.menuSelect === this.handOverApartmentEnum) {
          data.isMainContact = true;
          data.isOwner = true;
          data.isTenant = false;
        }
        if (
          this.menuSelect === this.addMemberIntoApartmentEnum ||
          this.menuSelect === this.memberRentApartmentEnum
        ) {
          data.isMainContact = false;
          data.isOwner = false;
          data.isTenant = false;
        }
        if (this.menuSelect === this.rentApartmentEnum) {
          data.isMainContact = true;
          data.isOwner = false;
          data.isTenant = true;
        }
        this.addResident({ data: data });
      } else {
        this.showError(result);
      }
    },
    addResident(payload) {
      this.ADD_RESIDENT({ data: payload.data })
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            this.onCloseModalAddCustomer();
          }.bind(this)
        )
        .catch(
          function(error) {
            //this.ERROR_TOAST();
            let mess =
              error.response.data.msg !== undefined
                ? error.response.data.msg
                : error.response.data.message;
            let data = {
              message: mess,
              styleType: "danger"
            };
            this.ON_SHOW_TOAST(data);
          }.bind(this)
        );
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_APARTMENT_LIST",
      "GET_USER_IN_APARTMENT_LIST",
      "ADD_RESIDENT"
    ])
  }
};
</script>
<style scoped>
/* .modal {
  text-align: center;
}

.modal:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
} */
.add-customer-in-apartment-item {
  padding: 4px 10px;
}
.add-customer-in-apartment-item:hover {
  background: #dfdfdf;
  cursor: pointer;
  /* padding: 4px 10px; */
}
</style>



// WEBPACK FOOTER //
// src/views/Customer/AddCustomerIntoApartment.vue